import styled from 'styled-components'

export const SectionHeadingTitle = styled.h2`
  ${({ theme }) => theme.typography['heading-md']};
  color: ${({ theme }) => theme.colors.BLACK_900};
  margin: 0;
`
